/**
 * Define exam question mixin
 *
 * @author minkyoung.park@emcast.com
 */
export const questionMixin = {
    
    data() {
        return {
            solveTimer: null,
            solveTime: 0,
            startDate: null,
        }
    },
    
    mounted() {
        this.startDate = Date.now()
    },

    methods: {
        // start timer
        startTimer() {
            this.solveTimer = setInterval( () => {
                this.solveTime += 1 
            }
            , 1000)
        },
        // clear timer
        clearTimer() {
            clearInterval(this.solveTimer)
        },
        
        // check correct
        isCorrect() {
            return this.question.correct
        }
    }
}